/**
 * i18next configuration.
 *
 * Two languages: Persian (fa, RTL) — default — and English (en, LTR).
 *
 * Language preference is managed via Redux (`uiSlice`) and persisted
 * in localStorage. This file just configures i18next; the actual
 * "current language" is set by `useLanguage()` hook.
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import fa from './locales/fa.json';
import en from './locales/en.json';

import { storageGet, STORAGE_KEYS } from '@/utils/storage';

const DEFAULT_LANGUAGE = import.meta.env.VITE_DEFAULT_LANGUAGE || 'fa';

// Read previously chosen language from storage; fallback to default.
const initialLanguage = storageGet(STORAGE_KEYS.LANGUAGE, DEFAULT_LANGUAGE);

i18n.use(initReactI18next).init({
  resources: {
    fa: { translation: fa },
    en: { translation: en },
  },
  lng: initialLanguage,
  fallbackLng: 'fa',
  interpolation: {
    escapeValue: false, // React already escapes
  },
  // This app has ONE namespace, and i18next's default would otherwise read a
  // colon inside a key as a namespace prefix: the analysis bots name their
  // muscle measures 'muscle:frontalis', and `t('…measure.muscle:frontalis')`
  // was being parsed as namespace '…measure.muscle', key 'frontalis'. The
  // lookup then failed silently and fell through to the English default, so a
  // Persian reader saw the bot's own wording. No key here uses `ns:key`
  // syntax, so turning the separator off costs nothing.
  nsSeparator: false,
  returnNull: false,
});

export default i18n;
